/**
 * Token cookie helpers, extracted from utils/index.ts so that Fetcher can
 * import them without creating a circular dependency
 * (fetcher -> utils/index -> requests/page -> fetcher).
 */
import Cookies from "js-cookie";

import { envs } from "./constants";

export const getTokenCookie = () => {
  return Cookies.get(envs.cookieKey) || "";
};

export const setTokenCookie = (token: string) => {
  Cookies.set(envs.cookieKey, token, {
    expires: 365 * 3,
    domain: envs.domain,
  });
};

export const removeTokenCookie = () => {
  Cookies.remove(envs.cookieKey, { domain: envs.domain });
};
